import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=3fd25c9c"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports